import { TypeCard } from '@/types/Card'
import { Commit } from 'vuex';

export default {
    namespaced: true,
    state: {
       CardData:<TypeCard>{
        cardid:'',
        cardtype:'',
        registerid:''
       }

    },
    getters: {
        // eslint-disable-next-line
        getCard: (state:any):TypeCard => state.CardData,
        // eslint-disable-next-line
        getRegisterID:(state:any):TypeCard=>state.CardData.registerid
    },
    mutations: {
        // eslint-disable-next-line
        SetCard(state:any, payload:TypeCard) {
            state.CardData = payload;
        },
       
    },
    actions: {
        SetCard({ commit }: { commit: Commit }, payload: TypeCard) : void{
            commit('SetCard', payload)
        },
    }
}